<template>
  <div class="inquiry-flow-app">
    <div class="inquiry-flow-app__selectors">
      <div class="inquiry-flow-app__selector-group">
        <label class="inquiry-flow-app__label">年代 <span class="inquiry-flow-app__optional-text">（任意）</span></label>
        <div class="select-wrap">
          <select v-model="selectedAge">
            <option value="NOT_SELECTED">年代を選択</option>
            <option value="INFANTS">乳幼児</option>
            <option value="UNDER_10">10歳未満</option>
            <option value="RANGE_10_19">10代</option>
            <option value="RANGE_20_29">20代</option>
            <option value="RANGE_30_39">30代</option>
            <option value="RANGE_40_49">40代</option>
            <option value="RANGE_50_59">50代</option>
            <option value="RANGE_60_69">60代</option>
            <option value="OVER_70">70代以上</option>
          </select>
        </div>
      </div>
      <div class="inquiry-flow-app__selector-group">
        <label class="inquiry-flow-app__label">性別 <span class="inquiry-flow-app__optional-text">（任意）</span></label>
        <div class="select-wrap">
          <select v-model="selectedGender">
            <option value="NOT_SELECTED">性別を選択</option>
            <option value="M">男性</option>
            <option value="F">女性</option>
          </select>
        </div>
      </div>
    </div>

    <button
      ref="startButtonRef"
      type="button"
      class="button button--primary button--lg button--flex inquiry-flow-app__start-button"
      @click="openDialog"
    >
      似ている相談事例を探す
      <span class="material-icons">search</span>
    </button>

    <InquiryFlowDialog
      :visible="isDialogOpen"
      :keyword="keyword"
      :target-age="selectedAge"
      :target-gender="selectedGender"
      @close="closeDialog"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import InquiryFlowDialog from './InquiryFlowDialog.vue';
import type { TargetAge, TargetGender } from '../types';

const props = defineProps<{
  keyword: string;
  targetAge: TargetAge;
  targetGender: TargetGender;
}>();

// 年代・性別の選択状態（propsから初期値を設定）
const selectedAge = ref<TargetAge>(props.targetAge);
const selectedGender = ref<TargetGender>(props.targetGender);

// ダイアログの表示状態
const isDialogOpen = ref(false);

// 開始ボタンへの参照（フォーカス管理用）
const startButtonRef = ref<HTMLButtonElement | null>(null);

// ダイアログを開く
const openDialog = () => {
  // 「似ている相談事例を探す」ボタンクリック時にGA送信
  window.sendGAEvent('問診LP', 'click', 'inquiry_flow_button');
  isDialogOpen.value = true;
};

// ダイアログを閉じる
const closeDialog = () => {
  isDialogOpen.value = false;
  // ダイアログを閉じた後、開始ボタンにフォーカスを戻す
  startButtonRef.value?.focus();
};
</script>

<style scoped lang="scss">
.inquiry-flow-app {
  // セレクターエリア
  &__selectors {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
    width: 100%;
  }

  &__selector-group {
    flex: 1;
    min-width: 140px;
    width: 48%;
    padding: 8px;
    border-radius: 4px;
  }

  &__label {
    display: block;
    font-weight: normal;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    text-align: left;
  }

  &__optional-text {
    color: #666;
    font-size: 12px;
    font-weight: normal;
    margin-left: 2px;
  }

  // 開始ボタン
  &__start-button {
    width: 100%;
    max-width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 10px;

    .material-icons {
      font-size: 1.875rem;
    }
  }
}
@media (max-width: 768px) {
  .inquiry-flow-app {
    &__selectors {
      gap: 4px;
    }
  }
}
// select-wrap スタイル（_forms.scss と同等）
.inquiry-flow-app .select-wrap {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 4px;
  background: #fff;
  padding: 0 24px 0 0;
  max-width: 100%;
  border: 1px solid #ccc;
  vertical-align: middle;
  width: 100%;

  &::before {
    position: absolute;
    pointer-events: none;
    content: '\e5c5';
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    background: #ffffff;
    padding-right: 8px;
    font-family: 'Material Icons';
    font-size: 24px;
  }

  select {
    border-radius: 0;
    border: 0;
    width: calc(100% + 24px);
    margin: 0;
    padding: 10px 12px;
    background: transparent;
    font-size: 16px;
    line-height: 1.2;
    color: inherit;
    outline: none;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-ms-expand {
      display: none;
    }

    &:-moz-focusring {
      color: transparent;
      text-shadow: 0 0 0 #333;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
